<template>
  <div>
    <b-modal
      v-if="isModalOpen"
      v-model="isModalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Modal"
      aria-modal
      v-bind="$attrs"
      @close="isModalOpen = false"
    >
      <div class="linktorequests_modal">
        <h1 class="header_title mb-3" style="text-align: left; width: 100%">
          {{ title }}
        </h1>
        <div class="header w-100">
          <div class="search__container w-100">
            <div class="input_search" style="width: 90%">
              <IconFilter class="icon is-small" />
              <input
                ref="searchServiceInput"
                v-model="searchPayload.text"
                type="text"
                class="input"
                placeholder="Type reviewer name or email"
                @input="
                  $emit('update:searchPayload', {
                    ...searchPayload,
                    text: $event.target.value,
                  })
                "
                @keyup.enter="searchRequests($event)"
              />
            </div>
            <button class="button_search ml-4" @click="searchRequests">
              <IconSearch
                slot="icon"
                class="icon is-small"
                style="width: 1.2rem"
              />
            </button>
          </div>
        </div>
        <p class="services_results_length">{{ resultsLength }} results</p>
        <div v-if="resultsLength > 0" class="results__container w-100">
          <button
            v-for="user in users.data"
            :key="user.id"
            :class="'item'"
            @click="
              () => handleItemClick({ userId: user.id, userName: user.name })
            "
          >
            <div>
              <div class="is-flex is-align-items-center gap-2">
                <div class="item__top">
                  {{ user.email }}
                </div>
              </div>
              <div class="item__bottom">
                {{ user.name }}
              </div>
            </div>
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { REQUEST_STAGES } from "@/constants/itinerary";
import Multiselect from "vue-multiselect";
import { USER_ROLE, USER_ROLE_IDS } from "@/constants";
import helpers from "@/helpers";

export default {
  name: "SetAssigneeModal",
  components: {
    Multiselect,
  },
  props: {
    title: {
      type: String,
      default: "Set Assignee to Quote",
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    isSetAssigneeModalOpen: {
      type: Boolean,
      default: false,
    },
    onContinue: {
      type: Function,
      default: () => {},
    },
    handleItemClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      filteredResults: [],
      isModalOpen: this.isSetAssigneeModalOpen,
      isLinkToRequestAlertOpen: false,
      searchPayload: {
        client: "",
        contract: "",
        stage: [],
        creation_date: "",
        text: "",
      },
      requestSelected: {},
    };
  },
  watch: {
    isModalOpen(newValue) {
      if (this.isSetAssigneeModalOpen === newValue) return;
      this.$emit("update:isSetAssigneeModalOpen", newValue);
    },
    isSetAssigneeModalOpen(newValue) {
      this.isModalOpen = newValue;
      this.$store.dispatch("utils/setIsModalOpen", newValue);
      if (newValue) this.onMounted();
      else this.resetComponentState();
    },
  },
  computed: {
    ...mapGetters({
      users: "users/getUsers",
      authData: "auth/getAuthData",
      itinerary: "itinerary/getItinerary",
      requests: "request/getRequests",
    }),
    resultsLength() {
      return this.users?.data?.length || 0;
    },
    isTravelAgent() {
      return helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.TRAVEL_AGENT],
        false
      );
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("request/SET_QUOTE_TO_LINK_TO_REQUEST", null);
    next();
  },
  methods: {
    buildSearchPayload() {
      return {
        client: this.itinerary.data ? this.itinerary.data.client.id : "",
        contract: this.itinerary.data ? this.itinerary.data.contract.id : "",
        stage: [
          REQUEST_STAGES.IN_PREPARATION,
          REQUEST_STAGES.SENT,
          REQUEST_STAGES.NEGOTIATION,
          REQUEST_STAGES.WON,
          REQUEST_STAGES.LOST,
        ],
        creation_date: "",
        text: "",
      };
    },
    updateSearchPayload(payload) {
      this.searchPayload = payload;
      this.filterServices();
    },
    closeLinkToRequestModal() {
      this.isModalOpen = false;
    },
    async onMounted() {
      this.searchPayload = this.buildSearchPayload();
      await this.searchRequests();
    },
    resetComponentState() {
      this.filteredResults = [];
    },
    async searchRequests(event) {
      event?.preventDefault?.();
      event?.stopPropagation?.();

      this.setLoading(true);

      const payloadRole = this.isTravelAgent
        ? [USER_ROLE_IDS.TRAVEL_AGENT]
        : [USER_ROLE_IDS.ADMIN, USER_ROLE_IDS.TRAVEL_AGENT];

      await this.$store.dispatch("users/getUsers", {
        page: 1,
        limit: 1000,
        name: this.searchPayload?.text || "",
        role: payloadRole.join(","),
      });

      this.filteredResults = this.requests.data;
      this.setLoading(false);
    },
  },
};
</script>

<style>
.linktorequests_modal .selectContainer {
  display: block;
}
.linktorequests_modal .btnClose {
  background-color: transparent;
  border: none;
  padding: 0;
}
.animation-content {
  z-index: 999;
}
.linktorequests_modal {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 36rem;
  height: 40rem;
  border-radius: 1rem;
  padding: 2rem 2rem 3rem;
  text-align: center;
  position: relative;
}
.linktorequests_modal .services_results_length {
  display: block;
  width: 100%;
  text-align: right;
  margin-top: 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #6d6d6d;
}
.header_title {
  font-size: 1.2rem;
  font-weight: 700;
  text-align: left;
  padding-top: 0.25rem;
  padding-bottom: 0.8rem;
}
.linktorequests_modal .select,
.linktorequests_modal select {
  width: 100%;
}

.linktorequests_modal .header {
  position: relative;
  width: 100%;
  text-align: left;
  padding-bottom: 0.2rem;
}
.linktorequests_modal .header .header_select {
  margin: 0.3rem 0;
  display: inline-block;
}
.linktorequests_modal .header .header_select :is(label) {
  text-align: left;
  margin-left: 0.25rem;
  font-size: 0.8rem !important;
}
.linktorequests_modal
  .header
  .header_select
  :is(.select, select, .b-form-datepicker.base-datePicker.form-control) {
  font-size: 0.8rem !important;
  width: 100% !important;
  border-radius: 0.5rem !important;
}
.linktorequests_modal
  .header
  .header_select
  :is(select:focus, .b-form-datepicker.base-datePicker.form-control:focus, .b-form-datepicker.base-datePicker.form-control:hover) {
  border-color: #f00b81 !important;
  box-shadow: 0 0 0 0.125em #f00b8138 !important;
}
.linktorequests_modal .header .header_select .select::after {
  border-color: #f00b81;
}
.linktorequests_modal .header .input_search {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.5rem;
  border-bottom: 1px solid #f00b81;
}
.linktorequests_modal .header .input_search .input {
  outline: none;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  width: 18rem;
}
.linktorequests_modal .header svg {
  color: #f00b81 !important;
  width: 1.2rem !important;
  height: 1.2rem !important;
}
.button_search {
  background: #f00b81;
  border: none;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
}
.linktorequests_modal .button_search :is(svg) {
  color: #fff !important;
}

.linktorequests_modal .footer__button {
  position: absolute;
  bottom: 1.5rem;
  left: 1rem;
}

.item {
  background-color: #fff;
  border: none;
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(217, 217, 217, 0.25);
  cursor: pointer;
  border-radius: 0.5rem;
}
.item.disabled {
  cursor: not-allowed;
  background-color: #eeeeee;
}
.item:hover {
  background-color: rgba(217, 217, 217, 0.25);
  border-radius: 0.5rem;
  color: #fff;
}
.item__top {
  font-size: 0.8rem;
  font-weight: 400;
  color: #6d6d6d;
}
.item__bottom {
  font-size: 0.8rem;
  font-weight: 600;
  color: #444444;
}

.linktorequests_modal .results__container {
  max-height: 100%;
  overflow-y: auto;
  margin-bottom: 2rem;
}

.form_stage__control label {
  text-align: left;
  margin-left: 0.25rem;
  font-size: 0.8rem !important;
}

.form_stage__control .multiselect__tag {
  margin-bottom: 0rem;
}

@media screen and (max-width: 480px) {
  .linktorequests_modal {
    padding: 1rem;
    height: 100%;
  }
}
</style>
